// Beheert de leden en de stagger-wachtrij van één animatiegroep.
class AnimationGroup {
	constructor(defaultDelay) {
		this.defaultDelay = defaultDelay;
		this.members = [];
		this.lastStart = -Infinity;
	}

	add(record) {
		this.members.push(record);
	}

	// De grouped-delay van een lid is de pauze vóór zijn eigen start,
	// gerekend vanaf de start van het vorige lid. Is dat moment al voorbij
	// (lege wachtrij), dan start het lid direct.
	claimReady(now) {
		let ready = this.members.filter(record => {
			return !record.isAnimated && record.inViewport;
		}).sort((a, b) => this.prioValue(a) - this.prioValue(b));

		return ready.map(record => {
			let delay = record.groupedDelay ?? this.defaultDelay;
			let start = Math.max(now, this.lastStart + delay);

			this.lastStart = start;

			return { record, delay: start - now };
		});
	}

	prioValue(record) {
		if (record.prio === 'first') return -Infinity;
		if (record.prio === 'last') return Infinity;
		return record.prio || 0;
	}
}

export default AnimationGroup;
